/**
 * Zjistí, zda má varianta atribut v dané hodnotě
 * 
 * @todo není dořešena kontrola pole hodnot attributů, např. barva u oblečení ["modrá", "červená", "bílá"] ...
 * 
 * @param variant
 * @param attribute
 * @param value
 */
export const hasVariantDefinition = (
  variant: GQL.IProductVariant, 
  attribute: GQL.IAttribute, 
  value: GQL.IAttributeValue
) => {
  if (variant && variant.definition && attribute && attribute.id && variant.definition[attribute.id]) {
    const definition = variant.definition[attribute.id];
    if (definition instanceof Array) {
      return definition.indexOf(value.id) >= 0;
    } else {
      return definition === value.id;
    }
  }

  return false;
};


// WEBPACK FOOTER //
// ./src/helpers/variants/hasVariantDefinition.ts